// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Invoice_ListInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for listing invoices
 *
 * Supports filtering by status, type, date range, customer document,
 * and pagination.
 */
import { registerContract } from './validate'

export interface Invoice_ListInput {
franchise_id?: number
cliente_id?: number
status?: string
invoice_type?: string
date_from?: string
date_to?: string
customer_doc?: string
page?: number
per_page?: number
year?: number
month?: number
}

registerContract('Invoice_ListInput', {
  franchise_id: { type: 'number',  required: false },
  cliente_id:   { type: 'number',  required: false },
  status:       { type: 'string',  required: false },
  invoice_type: { type: 'string',  required: false },
  date_from:    { type: 'string',  required: false },
  date_to:      { type: 'string',  required: false },
  customer_doc: { type: 'string',  required: false },
  page:         { type: 'number',  required: false },
  per_page:     { type: 'number',  required: false },
  year:         { type: 'number',  required: false },
  month:        { type: 'number',  required: false },
})
